module.exports = require("stripe");